module.exports = __webpack_public_path__ + "fonts/poppins-italic-webfont.b1859d6f.woff2";